import React from 'react';
import {IonCard, IonCardContent, IonIcon} from '@ionic/react';
import './TransactionCard.css';
import {fingerPrintOutline, repeatOutline} from "ionicons/icons";
import CurrencyDisplay from "./CurrencyDisplay";

interface TransactionCardProps {
    amount: number;
    description: string;
    date: Date | string;
    isTransaction: boolean;
}

const TransactionCard: React.FC<TransactionCardProps> = ({amount, description, date, isTransaction}) => {
    const parsedDate = date instanceof Date ? date : new Date(date);
    const isValidDate = !Number.isNaN(parsedDate.getTime());
    const formattedDate = isValidDate
        ? new Intl.DateTimeFormat('nl-NL', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(parsedDate)
        : String(date);

    const typeLabel = isTransaction ? 'Transactie' : 'Check-in';
    const amountClass = amount >= 0 ? 'transaction-card__amount--positive' : 'transaction-card__amount--negative';

    return (
        <IonCard className={`transaction-card ${isTransaction ? 'transaction-card--transaction' : 'transaction-card--checkin'}`}>
            <IonCardContent className="transaction-card__content">
                <div className="transaction-card__left">
                    <div className="transaction-card__icon-wrap" aria-hidden="true">
                        <IonIcon
                            className="transaction-card__icon"
                            icon={isTransaction ? repeatOutline : fingerPrintOutline}
                        />
                    </div>

                    <div className="transaction-card__meta">
                        <div className="transaction-card__topline">
                            <h3 className="transaction-card__title">{description || 'Onbekende mutatie'}</h3>
                            <span className="transaction-card__type">{typeLabel}</span>
                        </div>
                        <p className="transaction-card__date">{formattedDate}</p>
                    </div>
                </div>

                <div className={`transaction-card__amount ${amountClass}`}>
                    <CurrencyDisplay amount={amount}/>
                </div>
            </IonCardContent>
        </IonCard>
    );
};

export default TransactionCard;
